import React, { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import '../styles/entry-letter.css';

function EntryLetter({ onOpen }) {
  const [isOpen, setIsOpen] = useState(false);
  const [isUnfolded, setIsUnfolded] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const { t } = useLanguage();

  const handleSealClick = e => {
    e.stopPropagation();
    setIsOpen(true);
  };

  useEffect(() => {
    if (isOpen) {
      // Wait for envelope flap to rotate (600ms) + card to slide up & place (1000ms) before unfolding
      const timer = setTimeout(() => {
        setIsUnfolded(true);
      }, 1400);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  const handleEnterClick = e => {
    e.stopPropagation();
    setIsClosing(true);
    // Wait for the exit zoom/fade animation to complete before unmounting
    setTimeout(() => {
      onOpen();
    }, 850);
  };

  return (
    <div className={`entry-overlay ${isClosing ? 'exit-fade' : ''}`}>
      <div className="envelope-scaler">
        <div className={`envelope-container ${isOpen ? 'open' : ''} ${isClosing ? 'zoom-out' : ''}`}>
          {/* Envelope structure */}
          <div className="envelope">
            {/* Back flap */}
            <div className="envelope-back"></div>

            {/* Unfolding Save the Date Card */}
            <div className={`folded-card ${isUnfolded ? 'unfolded' : ''}`}>
              {/* Top Panel (Visible immediately from the getgo) */}
              <div className="card-panel panel-top">
                <img src="/save_the_date/saveTheDate_top.jpeg" alt="Save the Date Top" className="card-image" loading="eager" />
              </div>

              {/* Bottom Panel (Folds down from behind the top panel) */}
              <div className="card-panel panel-bottom">
                <img src="/save_the_date/saveTheDate_bottom.jpeg" alt="Save the Date Bottom" className="card-image" loading="eager" />
              </div>

              {/* Enter CTA positioned below the unfolded card */}
              <button className="enter-button" onClick={handleEnterClick}>
                {t('continue')}
              </button>
            </div>

            {/* Front side flaps (left & right overlap) with shadow wrappers */}
            <div className="envelope-right-shadow">
              <div className="envelope-right"></div>
            </div>
            <div className="envelope-left-shadow">
              <div className="envelope-left"></div>
            </div>

            {/* Bottom flap with shadow wrapper */}
            <div className="envelope-bottom-shadow">
              <div className="envelope-bottom"></div>
            </div>

            {/* Top flap (hinges from the top) with shadow wrapper */}
            <div className={`envelope-top-shadow ${isOpen ? 'open' : ''}`}>
              <div className="envelope-top"></div>
            </div>

            {!isOpen && (
              <button className="wax-seal" onClick={handleSealClick} aria-label="Open invitation seal">
                <img src="/save_the_date/wax_seal.png" alt="Wax Seal" className="wax-seal-img" />
                <span className="seal-prompt">{t('clickToOpen')}</span>
              </button>
            )}
          </div>
        </div>
        {/* Side decorative floral elements, placed after envelope-container to allow sibling styling in CSS */}
        {/* Left Side Cluster */}
        {/* <img 
          src="/flowers/IMG-20251023-WA0003.png" 
          alt="" 
          className="envelope-decor-flower decor-left-1"
        />
        <img 
          src="/flowers/IMG-20251023-WA0008.png" 
          alt="" 
          className="envelope-decor-flower decor-left-2"
        />
        <img 
          src="/flowers/IMG-20251023-WA0009.png" 
          alt="" 
          className="envelope-decor-flower decor-left-3"
        /> */}

        {/* Right Side Cluster */}
        {/* <img src="/flowers/IMG-20251023-WA0006.png" alt="" className="envelope-decor-flower decor-right-1" />
        <img src="/flowers/IMG-20251023-WA0011.png" alt="" className="envelope-decor-flower decor-right-2" /> */}
      </div>
    </div>
  );
}

export default EntryLetter;
